export const ACTIONS = {
  UPDATE: 'SERVER_DATA_UPDATE',
  CLEAR: 'SESSION_CLEAR',
};

export const STORAGE_SERVER_DATA_NAMESPACE = 'local_server_data_space';
